import { DateTime } from 'luxon';

export function stringToViewDate(date: string): DateTime<true> {
  return DateTime.fromISO(date) as DateTime<true>;
}
